import React from "react";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";
import { Form } from "@weezevent/nacre";

/**
 * A controlled radio button component integrated with react-hook-form.
 * Must be wrapped by a FormContext.
 */
const FormFieldRadioLabel = ({
	name,
	control,
	value: radioValue,
	label,
	children,
	disabled,
	onChange: onExternalChange,
	...props
}) => {
	const {
		field: { onChange, value },
		fieldState: { error }
	} = useController({
		name,
		control
	});

	const handleChange = () => {
		onChange(radioValue);
		if (onExternalChange) {
			onExternalChange(radioValue);
		}
	};

	return (
		<Form.RadioLabel
			bordered
			inline
			name={name}
			value={radioValue}
			checked={value === radioValue}
			onChange={handleChange}
			errors={!!error}
			disabled={disabled}
			{...props}
		>
			{label}
			{children}
		</Form.RadioLabel>
	);
};

FormFieldRadioLabel.propTypes = {
	name: PropTypes.string.isRequired,
	control: PropTypes.object,
	value: PropTypes.string.isRequired,
	label: PropTypes.string,
	children: PropTypes.node,
	onChange: PropTypes.func,
	disabled: PropTypes.bool
};

FormFieldRadioLabel.defaultProps = {
	control: {},
	label: "",
	children: null,
	onChange: () => {},
	disabled: false
};

export default FormFieldRadioLabel;
